import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/solid/{S,M,L}/ointment.svg` */
export const OintmentSolidIcon = createTripletGlyphIcon('OintmentSolidIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.9117 1.65808C7.35118 1.65815 7.69353 2.03941 7.64705 2.47644L7.337 5.39267H7.35018L7.26591 6.06134L6.566 12.6444H6.56288V13.7254C6.56288 14.0659 6.28686 14.3419 5.94638 14.3419H2.79437C2.45389 14.3419 2.17787 14.0659 2.17787 13.7254V12.622L1.09725 2.47644C1.05072 2.03934 1.39401 1.65808 1.83358 1.65808H6.9117ZM6.51131 2.75769L6.23106 5.39267H2.51382L2.23299 2.75769H6.51131ZM3.16951 11.5448L2.85323 8.57724H5.89236L5.57674 11.5448H3.16951Z"
        fill="currentColor"
      />
      <path
        d="M14.1549 9.56019C14.1549 9.56019 14.0983 9.82653 14.0644 9.86677L9.03848 9.86685C9.10571 9.43002 9.40777 8.67517 9.83704 8.53199C10.4914 8.31387 11.1991 8.34825 11.8296 8.62834L12.1293 8.76127C12.3501 8.85964 12.6011 8.85419 12.8174 8.74582C13.142 8.58354 13.2847 8.05166 13.2135 7.69596C13.1972 7.61417 13.2385 7.53181 13.3135 7.49596C13.3886 7.46027 13.4785 7.47962 13.532 7.54368C13.532 7.54368 13.926 7.88868 14.0644 8.1824C14.2599 8.59723 14.1549 9.56019 14.1549 9.56019Z"
        fill="currentColor"
      />
      <path
        d="M14.9079 10.6115C14.9077 10.4074 14.7419 10.2424 14.5378 10.2424H8.4499C8.24575 10.2424 8.08002 10.4074 8.07978 10.6115V13.1086C8.07978 13.7894 8.63138 14.3418 9.31221 14.342H13.6745C14.3555 14.342 14.9079 13.7895 14.9079 13.1086V10.6115Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.77548 1.86536C8.26983 1.86536 8.65565 2.29373 8.60361 2.78528L8.25456 6.06678H8.26822L8.18038 6.76412L7.38681 14.2247H7.38335V15.4411C7.38335 15.8242 7.07283 16.1347 6.68979 16.1347H3.14378C2.76074 16.1347 2.45022 15.8242 2.45022 15.4411V14.1966L1.23544 2.78528C1.18335 2.29372 1.56823 1.86538 2.06259 1.86536H7.77548ZM7.47861 2.96497L7.14857 6.06678H2.69078L2.36044 2.96497H7.47861ZM3.44247 13.1251L3.07226 9.64881H6.76744L6.39755 13.1251H3.44247Z"
        fill="currentColor"
      />
      <path
        d="M15.9244 10.7552C15.9244 10.7552 15.8607 11.0549 15.8226 11.1001L10.1684 11.1002C10.2441 10.6088 10.5839 9.75959 11.0668 9.59852C11.8029 9.35313 12.5991 9.39181 13.3084 9.70691L13.6456 9.85645C13.894 9.96712 14.1763 9.961 14.4197 9.83907C14.7848 9.65651 14.9455 9.05815 14.8653 8.65798C14.8469 8.56597 14.8934 8.47332 14.9778 8.43298C15.0623 8.39283 15.1634 8.4146 15.2237 8.48667C15.2237 8.48667 15.6668 8.87479 15.8226 9.20523C16.0426 9.67191 15.9244 10.7552 15.9244 10.7552Z"
        fill="currentColor"
      />
      <path
        d="M16.7716 11.9387C16.7716 11.709 16.5853 11.5228 16.3556 11.5227H9.50597C9.27614 11.5227 9.08996 11.7089 9.08996 11.9387V14.7473C9.08996 15.5133 9.71065 16.1349 10.4767 16.135H15.3839C16.15 16.135 16.7716 15.5134 16.7716 14.7473V11.9387Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4888 2.49396C11.0883 2.55909 11.5365 3.09997 11.4712 3.71466L11.006 8.08905H11.0251L10.9028 9.05847L9.84913 18.9656H9.84432V20.5882C9.84432 21.0989 9.43029 21.513 8.91957 21.513H4.19153C3.6808 21.513 3.26678 21.0989 3.26678 20.5882V18.9259L1.64699 3.71466C1.58154 3.09993 2.02884 2.5591 2.62843 2.49396L2.7505 2.48712H10.3677L10.4888 2.49396ZM10.1558 3.78693L9.69838 8.08905H3.41944L2.96144 3.78693H10.1558ZM4.43898 17.6658L3.92793 12.8654H9.19056L8.68019 17.6658H4.43898Z"
        fill="currentColor"
      />
      <path
        d="M21.2325 14.3404C21.2325 14.3404 21.1476 14.7399 21.0968 14.8002L13.5579 14.8004C13.6587 14.1451 14.1118 13.0128 14.7557 12.7981C15.7372 12.4709 16.7988 12.5225 17.7446 12.9426L18.1942 13.142C18.5253 13.2895 18.9018 13.2814 19.2263 13.1188C19.7131 12.8754 19.9273 12.0776 19.8204 11.544C19.7959 11.4213 19.8579 11.2978 19.9705 11.244C20.083 11.1905 20.2179 11.2195 20.2983 11.3156C20.2983 11.3156 20.8891 11.8331 21.0968 12.2737C21.3901 12.8959 21.2325 14.3404 21.2325 14.3404Z"
        fill="currentColor"
      />
      <path
        d="M22.3619 15.9183C22.3619 15.6119 22.1135 15.3638 21.8072 15.3636H12.6744C12.368 15.3636 12.1197 15.6118 12.1197 15.9183V19.6634C12.1197 20.6848 12.9479 21.513 13.9694 21.513H20.5123C21.5338 21.513 22.3619 20.6848 22.3619 19.6634V15.9183Z"
        fill="currentColor"
      />
    </svg>
  ),
});
